import {
  Location,
} from '@angular/common';
import { Injectable } from '@angular/core';
import {
  StateService,
} from '@uirouter/angular';

import {
  AppRoute,
  AprimaTransitionRequest,
  WebViewManager,
} from 'webcommon/shared';

@Injectable({
  providedIn: 'root',
})
export class BrowserWebViewManager implements WebViewManager {
  constructor(
    private location: Location,
    private stateService: StateService,
  ) {

  }

  activateState(state: string, transition: AprimaTransitionRequest): boolean {
    const opts = transition.opts;
    if (opts?.replaceCurrentState === true) {
      this.stateService.go(state, opts, {location: 'replace'});
    } else {
      this.stateService.go(state, opts);
    }
    return true;
  }

  activateView(appRoute: AppRoute, transition: AprimaTransitionRequest): boolean {
    return this.activateState(appRoute.state, transition);
  }

  goBack(): void {
    this.location.back();
  }
}
